import { Injectable } from '@angular/core';
import { Auth } from './auth/auth.service';

export type UiMode = 'classic' | 'studio';

/**
 * Chooses which UI a client sees:
 *  · 'studio'  — the macOS-style "Coating Studio" (src/app/fittings, topbar, login)
 *  · 'classic' — the original Bootstrap UI (src/app/legacy)
 *
 * Every client gets the studio UI. The classic one is kept only so it can be
 * brought back by returning 'classic' from here (and in index.html).
 */
@Injectable()
export class UiService {
  private readonly key = 'ui';
  public mode: UiMode = 'studio';

  get isStudio(): boolean { return this.mode === 'studio'; }

  public init() {
    this.apply('studio');
  }

  /** Call on every auth change. */
  public resolve(auth: Auth) {
    this.apply('studio');
  }

  private apply(mode: UiMode) {
    this.mode = mode;
    document.documentElement.setAttribute('data-ui', mode);
    // Bootstrap is only for the classic UI
    const link = document.getElementById('bootstrap-css') as HTMLLinkElement;
    if (link) { link.disabled = (mode !== 'classic'); }
    try { localStorage.setItem(this.key, mode); } catch (e) { /* private mode */ }
  }
}
